// src/hooks/pricingUnits/useGetPricingUnits.js
import { useQuery } from "@tanstack/react-query";
import { getAllPricingUnits } from "../../api/apiPricingUnits";

const QUERY_KEY = ["pricingUnits"];

const useGetPricingUnits = (page = 1, perPage = 15, filters = {}) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [...QUERY_KEY, page, perPage, filters],
        queryFn: () => getAllPricingUnits(page, perPage, filters),
        keepPreviousData: true,
    });

    return {
        isLoading,
        error: isError ? error : null,
        pricingUnits: data?.data || data?.pricingUnits || [],
        meta: data?.data?.meta || null,
    };
};

export default useGetPricingUnits;
